import * as React from 'react';
import { History } from 'history';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import OrganisationStore from '../stores/OrganisationStore';
import OrganisationListCell from './OrganisationListCell';


export interface Props {
    history: History;
}

@observer export default class OrganisationsList extends React.PureComponent<Props> {
    @observable orgs: Array<any> = [];

    componentDidMount() {
        this._listOrgs();
    }

    render() {
        return (
            <div>
                <h1>Organisations</h1>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Created At</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.orgs.map(i => <OrganisationListCell key={i.uuid} organisation={i} />)}
                    </tbody>
                </table>
            </div>
        );
    }

    _listOrgs = () => {
        OrganisationStore.getList()
        .then((orgs) => {
            this.orgs = orgs;
        })
        .catch(() => {
            // Show error and clear code
            alert('Failed to list orgs');
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/OrganisationsList.tsx